import { createSelector } from "@reduxjs/toolkit";

import { nodeIdParamSelector } from "@skilitics/nautilus-core-designer-data";

import { getNodeTitleCreate } from "../getNodeTitle.ts";
import { getLayoutCustomTitleForContentNodeSelector } from "../layoutSelectors/index.ts";
import { getManifestSelector } from "./appConfigSelectors.ts";
import { getDesignerNodeByIdSelector } from "./designerNodeSelectors.ts";
import { getParentContextByIdSelector } from "./parentContextSelectors.ts";

export const getNodeTitleSelector = createSelector(
  [getManifestSelector, getParentContextByIdSelector, getLayoutCustomTitleForContentNodeSelector],
  (getManifest, getParentContext, getLayoutTitle) =>
    getNodeTitleCreate({ getManifest, getParentContext, getLayoutTitle }),
);

export type GetNodeTitleById = (nodeId: number) => string;

export const getNodeTitleByIdSelector = createSelector(
  [getNodeTitleSelector, getDesignerNodeByIdSelector],
  (getNodeTitle, getDesignerNodeById): GetNodeTitleById =>
    (nodeId) =>
      getNodeTitle(getDesignerNodeById(nodeId)),
);

export const nodeTitleSelector = createSelector(getNodeTitleByIdSelector, nodeIdParamSelector, (getNodeTitle, nodeId) =>
  getNodeTitle(nodeId),
);
